import type { BoardPostDetail, CreateBoardPostReq, UpdateBoardPostReq } from '@/services/board/types'
import { NOTICE_CATEGORY } from './consts'
import type { BoardFormValues } from './schemas/boardFormSchema'

/**
 * 첨부를 올릴 화주 — 서버가 키를 `{env}/{글 화주}/` 로 검증한다(SPEC attachment_keys).
 * 수정은 글 화주 그대로(서버가 화주를 바꾸지 않는다), 공지 등록은 공지 대상, 일반 글은 소속 화주.
 */
export const uploadShipperFor = ({
  editShipper,
  category,
  noticeTarget,
  homeShipper,
}: {
  editShipper?: string
  category: string
  noticeTarget?: string
  homeShipper: string
}): string | undefined => {
  if (editShipper) return editShipper
  if (category === NOTICE_CATEGORY) return noticeTarget || undefined
  return homeShipper || undefined
}

export const toCreateReq = (values: BoardFormValues, attachmentKeys: string[]): CreateBoardPostReq => ({
  category: values.category,
  title: values.title.trim(),
  content: values.content,
  attachmentKeys,
  ...(values.category === NOTICE_CATEGORY ? { noticeTarget: values.noticeTarget } : {}),
})

/** 수정은 공지 대상을 보내지 않고, 새 키만 `attachmentKeys` 에, 남길 기존 첨부는 순번으로 보낸다. */
export const toUpdateReq = (values: BoardFormValues, attachmentKeys: string[], keepFileIndexes: number[]): UpdateBoardPostReq => ({
  category: values.category,
  title: values.title.trim(),
  content: values.content,
  attachmentKeys,
  keepFileIndexes,
})

/**
 * 수정 화면에 폼을 그려도 되는가. 폼 초기값·남길 첨부 순번은 첫 렌더 값으로 굳으므로 최신 응답일 때만 그린다(LOGISPRD-17143).
 * 다시 받기가 실패하면 react-query 는 이전 data 를 남긴다 — 그 옛 값으로 폼을 열면 다시 저장할 때 직전 수정을 덮는다.
 */
export const editFormGate = ({
  isLoading,
  isFetching,
  isError,
  post,
}: {
  isLoading: boolean
  isFetching: boolean
  isError: boolean
  post: BoardPostDetail | undefined
}): 'loading' | 'error' | 'notFound' | 'notEditable' | 'ready' => {
  if (isLoading || isFetching) return 'loading'
  if (isError) return 'error'
  if (!post) return 'notFound'
  return post.editable ? 'ready' : 'notEditable'
}
